module.exports = __webpack_public_path__ + "static/media/CourrierElectroniqueSimple.b3ee4ca4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDF/CourrierElectroniqueSimple.pdf
// module id = 757
// module chunks = 0